import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { InvitationListHeader } from '@components/InvitationListItem'
import { InvitationListItem } from '@components/InvitationListItem'
import useContacts from '@/hooks/useContacts'
import type { Contact } from '@services/contribution/contribution'
import StackedList from '@components/StackedList'
import { sort } from '@/util/sorters'
import LoadingScreen from '@/components/LoadingScreen'

function findParent(contacts: Contact[]) {
  const sorted = contacts.sort((a, b) => a.id - b.id)
  return {
    parent: sorted[0],
    otherContacts: sorted.slice(1),
  }
}

export default function InvitationList() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { contacts, isLoading, error } = useContacts()

  if (isLoading) return <LoadingScreen />
  if (error) return <div>Error: {(error as Error).message}</div>

  if (!contacts || contacts.length === 0) {
    return null
  }

  const { parent, otherContacts } = findParent(contacts)

  return (
    <div className='flex flex-col gap-6 mb-4'>
      <StackedList
        title={t('content.components.current_contacts.title')}
        Header={InvitationListHeader}
        description={t('content.components.current_contacts.subtitle')}
        renderItem={({ item: contact, index }: { item: Contact; index: number }) => (
          <InvitationListItem
            key={contact.id}
            contact={contact}
            isParent={index === 0}
            onClick={(contact: Contact) => navigate(`../contact/${contact.id}`)}
          />
        )}
        data={[parent].concat(...sort(otherContacts, 'NAME_ASC'))} //sort by fullname
      />
    </div>
  )
}
